import { FETCH_VEHICLE_MODEL, GET_VEHICLE_MODEL, CREATE_VEHICLE_MODEL, UPDATE_VEHICLE_MODEL, DELETE_VEHICLE_MODEL } from 'actions/vehicleModel';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* fetchVehicleModel(action) {
  try {
    const response = yield call(API.getVehicleModel, action.payload);
    yield put({ type: FETCH_VEHICLE_MODEL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_VEHICLE_MODEL.FAIL, payload: { error: e } });
  }
}

function* getVehicleModelById(action) {
  try {
    const response = yield call(API.getVehicleModelById, action.payload);
    yield put({ type: GET_VEHICLE_MODEL.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_VEHICLE_MODEL.FAIL, payload: { error: e } });
  }
}

function* createVehicleModel(action) {
  try {
    const response = yield call(API.addVehicleModel, action.payload);
    yield put({ type: CREATE_VEHICLE_MODEL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_VEHICLE_MODEL.FAIL, payload: { error: e } });
  }
}

function* updateVehicleModel(action) {
  try {
    const response = yield call(API.updateVehicleModel, action.payload);
    yield put({ type: UPDATE_VEHICLE_MODEL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_VEHICLE_MODEL.FAIL, payload: { error: e } });
  }
}

function* deleteVehicleModel(action) {
  try {
    const response = yield call(API.deleteVehicleModel, action.payload);
    yield put({ type: DELETE_VEHICLE_MODEL.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_VEHICLE_MODEL.FAIL, payload: { error: e } });
  }
}

function* vehicleModel() {
  yield takeLatest(FETCH_VEHICLE_MODEL.REQUEST, fetchVehicleModel);
  yield takeLatest(GET_VEHICLE_MODEL.REQUEST, getVehicleModelById);
  yield takeLatest(CREATE_VEHICLE_MODEL.REQUEST, createVehicleModel);
  yield takeLatest(UPDATE_VEHICLE_MODEL.REQUEST, updateVehicleModel);
  yield takeLatest(DELETE_VEHICLE_MODEL.REQUEST, deleteVehicleModel);
}

export default vehicleModel;
